import React from 'react'

function Iosapp() {
  return (
    <div>
      {/* Hero Start */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="display-4 text-white mb-4 animated slideInRight">iOS App Development</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/index">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">iOS App</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Bluevipers Technology develops feature-rich, secure, and scalable iOS applications that offer seamless user experience. 
                From concept to deployment on the App Store, we ensure your app stands out in the market.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="iOS App" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>
      {/* Hero End */}

      {/* Feature Start */}
      <div className="container-fluid bg-dark feature pt-5">
        <div className="container pt-5">
          <div className="row g-5">
            <div className="col-lg-12 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
              <div className="btn btn-sm border rounded-pill text-white px-3 mb-3">Why Choose Us</div>
              <h1 className="text-white mb-4">Expert iOS App Development with Seamless UX</h1>
              <p className="text-light mb-4">
                We design and develop iOS apps with the latest Swift and Objective-C technologies, delivering apps that are fast, secure, and scalable. 
                Our focus is on creating intuitive interfaces and exceptional user experience for your customers.
              </p>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Custom iOS App Development</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>Intuitive and Modern UI/UX</span>
              </div>
              <div className="d-flex align-items-center text-white mb-3">
                <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                  <i className="fa fa-check" />
                </div>
                <span>App Store Deployment & Support</span>
              </div>
            
            </div>
          
          </div>
        </div>
      </div>
      {/* Feature End */}

      {/* Contact Section */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center">
          <h2 className="text-white mb-4">Contact Us for Your iOS App</h2>
          <p className="text-white-50 mb-2">
            Call us at <strong>+91 8459432930</strong>
          </p>
          <p className="text-white-50 mb-4">
            Email: <strong>blueviperstechnology@gmail.com</strong>
          </p>
          <a href="/contact" className="btn btn-light rounded-pill px-4 py-2">Contact Now</a>
        </div>
      </div>
      {/* Contact Section End */}
    </div>
  )
}

export default Iosapp
